import React from 'react';

import { renderWhenTrueOr } from '../../utils';

import { CompanyLogoData } from './companyLogo.types';
import { LogoType, LogoVersion } from './companyLogo.enums';
import { TextLogo, ImageLogo, LocalLink } from './companyLogo.styled';

export const CompanyLogo: React.FC<CompanyLogoData> = (data: CompanyLogoData) => {
  const { logoData, version, target } = data;
  const { logoType, textLogo, imageLogo } = logoData;

  const renderTextLogo = () => (
    <TextLogo isLightVersion={version === LogoVersion.Light}>{textLogo}</TextLogo>
  );

  const renderImageLogo = () => (
    <ImageLogo src={imageLogo?.localFile?.url} />
  );

  const renderLogo = renderWhenTrueOr(
    renderTextLogo,
    renderImageLogo
  );

  return (
    <LocalLink to={target}>
      {renderLogo(logoType === LogoType.Text)}
    </LocalLink>
  );
}
